import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.string.trim.js";
var flag = 0;
var img;
var img1;
var img3;
var commentParams = {
  'filter[thread]': '',
  sort: 'createdAt',
  page: 1,
  perPage: 20,
  index: 1
};
var params = {
  isComment: 1,
  id: '',
  content: '',
  replyId: '',
  commentPostId: ''
};
import { detail, comments, follow, unFollow, postComments, thumbs, collect, signUp, threadDelete } from '@/api/mg';
import getPx from '@/utils/getPx';
import QRCode from 'qrcodejs2';
import $ from 'jquery';
import md5 from 'md5';
var jsonp = require('jsonp');
export default {
  watch: {
    show: function show() {
      this.item.isSelected = this.show;
    }
  },
  data: function data() {
    return {
      show: false,
      placeholder: 'Say something',
      commentList: [],
      detailData: {
        content: {
          text: ''
        },
        user: {
          avatar: ''
        }
      },
      isEmpty: true,
      isFocus: false,
      isFollow: true,
      inputValue: '',
      threadId: '',
      userId: '',
      storeUserId: '',
      qrcode: '',
      item: '',
      canvasImgSrc: '',
      shiftArr: [],
      isCommentShow: false
    };
  },
  created: function created() {
    flag = 0;
    this.storeUserId = localStorage.getItem('userId');
    this.title = this.$route.query.from;
    this.threadId = this.$route.query.threadId;
    console.log(this.title, this.threadId);
    var params = {
      threadId: this.threadId
    };
    this.getDetail(params);
    commentParams['filter[thread]'] = this.threadId;
    this.getComments(commentParams);
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var timer = setTimeout(function () {
        _this.creatQrCode();
        // this.handleResize()
        // const video = document.querySelector('.video')
        // this.autoFullScrenn(video)
        clearTimeout(timer);
      }, 1000);
    });
  },
  methods: {
    translate: function translate(detailData) {
      var _this2 = this;
      var appid = '20211116001000645'; // 百度翻译API的appid
      var key = 'RExx85Y9o4DqUHOrcaqV'; // 百度翻译API的key
      var salt = new Date().getTime();
      var query = detailData.content.text;
      var from = 'th';
      var to = 'en';
      var str1 = appid + query + salt + key;
      var sign = md5(str1);
      var url = "http://api.fanyi.baidu.com/api/trans/vip/translate?q=".concat(query, "&appid=").concat(appid, "&salt=").concat(salt, "&from=").concat(from, "&to=").concat(to, "&sign=").concat(sign);
      jsonp(url, null, function (err, data) {
        if (err) {
          _this2.$toast(err.error_msg);
        } else {
          detailData.content.text = data.trans_result[0].dst;
        }
      });
    },
    toDelete: function toDelete(threadId) {
      var _this3 = this;
      threadDelete({
        threadId: threadId
      }).then(function (res) {
        if (res.Code === 0) {
          _this3.$router.back();
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    toMe: function toMe(pid) {
      //this.$router.push({ path: '/others', query: { pid } })
    },
    toSign: function toSign(type) {
      var _this4 = this;
      signUp({
        threadId: this.threadId,
        type: type,
        token: JSON.parse(localStorage.getItem('appParams')).token
      }).then(function (res) {
        if (res.Code === 0) {
          _this4.$toast(res.Message);
          var _params = {
            threadId: _this4.threadId
          };
          _this4.getDetail(_params);
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId
        }
      });
    },
    toCollect: function toCollect(isFavorite, threadId) {
      var _this5 = this;
      var params = {
        id: threadId,
        isFavorite: !isFavorite
      };
      collect(params).then(function (res) {
        if (res.Code === 0) {
          var _params2 = {
            threadId: _this5.threadId
          };
          _this5.getDetail(_params2);
        } else {
          _this5.$toast(res.Message);
        }
      });
    },
    imgLoad: function imgLoad() {
      // MG图片
      img1 = new Image();
      img1.src = require('../../assets/images/MG_1.png');
      img1.onload = function () {
        flag++;
        console.log('MG图片加载完成', img1, flag);
      };
      // 头像
      img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        flag++;
        console.log('头像加载完成', img, flag);
      };
      if (this.detailData.user.avatar) {
        img.src = this.detailData.user.avatar + '?time=' + new Date().valueOf();
      }
      // 背景图片
      img3 = new Image();
      img3.src = require('../../assets/images/P8.png');
      img3.onload = function () {
        flag++;
        console.log('背景图片加载完成', img3, flag);
      };
    },
    fullscreen: function fullscreen(elem) {
      var prefix = 'webkit';
      if (elem[prefix + 'EnterFullScreen']) {
        return prefix + 'EnterFullScreen';
      } else if (elem[prefix + 'RequestFullScreen']) {
        return prefix + 'RequestFullScreen';
      }
      return false;
    },
    autoFullScrenn: function autoFullScrenn(v) {
      var ua = navigator.userAgent.toLowerCase();
      var Android = String(ua.match(/android/i)) === 'android';
      if (!Android) return; // 非android系统不使用;
      var video = v;
      var doc = document;
      var fullscreenvideo = this.fullscreen(doc.createElement('video'));
      if (!this.fullscreen) {
        this.$toast('不支持全屏模式');
        return;
      }
      video.addEventListener('webkitfullscreenchange', function (e) {
        if (!doc.webkitIsFullScreen) {
          // 退出全屏暂停视频
          this.pause();
          // this.pause();
        }
      }, false);
      video.addEventListener('click', function () {
        this.play();
        video[fullscreenvideo]();
      }, false);
      video.addEventListener('ended', function () {
        doc.webkitCancelFullScreen(); // 播放完毕自动退出全屏
      }, false);
    },
    creatQrCode: function creatQrCode() {
      var _this6 = this;
      new QRCode(this.$refs.qrCodeUrl, {
        text: location.href.replace('detail', 'share'),
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
      this.$nextTick(function () {
        _this6.qrcode = document.querySelector('.qrcode canvas');
        console.log(_this6.qrcode, 'this.qrcode');
      });
    },
    toComment: function toComment(pid) {
      this.$router.push({
        path: '/social/comment',
        query: {
          pid: pid,
          threadId: this.threadId
        }
      });
    },
    del: function del() {
      var params = {
        pid: this.pid,
        data: {
          attributes: {
            isDeleted: true
          }
        }
      };
      this.thumpsApi(params, 'delete');
    },
    cancel: function cancel() {
      this.item.isSelected = false;
      this.show = false;
    },
    start: function start(userId, pid, item) {
      this.blur();
      this.userId = userId;
      this.pid = pid;
      this.item = item;
    },
    longpress: function longpress() {
      console.log('进入langPress', localStorage.getItem('userId'), this.userId, this.item);
      if (localStorage.getItem('userId') === this.userId + '') {
        this.item.isSelected = true;
        this.show = true;
      }
    },
    thumbsUp: function thumbsUp(pid, isLike, threadId) {
      if (threadId) {
        var _params3 = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid,
          id: threadId
        };
        this.thumpsApi(_params3, 'thread');
      } else {
        var _params4 = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid
        };
        this.thumpsApi(_params4, 'comment');
      }
    },
    thumpsApi: function thumpsApi(params, type) {
      var _this7 = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (type === 'delete') {
            _this7.item.isSelected = false;
            _this7.show = false;
            _this7.getComments(commentParams);
          }
          if (type === 'comment') {
            _this7.getComments(commentParams);
          }
          if (type === 'thread') {
            var _params5 = {
              threadId: _this7.threadId
            };
            _this7.getDetail(_params5);
          }
        } else {
          _this7.$toast(res.Message);
        }
      });
    },
    toReply: function toReply(name, replyId, commentPostId) {
      this.$refs.inputs.focus();
      params.replyId = replyId;
      if (commentPostId) {
        params.commentPostId = commentPostId;
      } else {
        params.commentPostId = '';
      }
      console.log(params, 'params');
      this.placeholder = 'reply ' + name + ':';
    },
    post: function post(params) {
      var _this8 = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      postComments(params).then(function (res) {
        if (res.Code === 0) {
          _this8.item = '';
          params.replyId = '';
          _this8.placeholder = 'Say something';
          _this8.getComments(commentParams);
        } else {
          _this8.$toast(res.Message);
          var _params6 = {
            threadId: _this8.threadId
          };
          _this8.getDetail(_params6);
        }
      });
    },
    getComments: function getComments(params) {
      var _this9 = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      comments(params).then(function (res) {
        if (res.Code === 0) {
          _this9.commentList = res.Data.pageData;
          _this9.isCommentShow = true;
        } else {
          _this9.$toast(res.Message);
        }
      });
    },
    getDetail: function getDetail(params) {
      var _this10 = this;
      detail(params).then(function (res) {
        if (res.Code === 0) {
          _this10.detailData = res.Data;
          if (_this10.detailData['content']['indexes'] == '[object Object]' && _this10.detailData['content']['indexes']['101']['body'].length > 0) {
            var data = JSON.parse(JSON.stringify(_this10.detailData['content']['indexes']['101']['body']));
            if (data[0].type === 1 || data[0].type === 0) {
              data.shift();
            }
            _this10.shiftArr = data;
            console.log(_this10.detailData['content']['indexes']['101']['body']);
          }
          if (!_this10.detailData.user.avatar) {
            _this10.detailData.user.avatar = require('../../assets/images/icon_avatar.png');
          }
          _this10.imgLoad();
          console.log(_this10.detailData, 'this.detailData');
        } else {
          _this10.$toast(res.Message);
          var timer = setTimeout(function () {
            _this10.$router.back();
            clearTimeout(timer);
          }, 1000);
        }
      });
    },
    send: function send() {
      if (this.inputValue.trim()) {
        if (params.replyId) {
          params.content = this.inputValue;
          params.id = this.threadId;
          this.post(params);
        } else {
          var params1 = {
            id: this.threadId,
            content: this.inputValue.trim()
          };
          this.post(params1);
        }
        this.isFocus = false;
        this.inputValue = '';
        this.isEmpty = true;
      }
    },
    input: function input(val) {
      if (val.trim()) {
        this.isEmpty = false;
      } else {
        this.isEmpty = true;
      }
    },
    isIos: function isIos() {
      var m = navigator.userAgent;
      var isIos = !!m.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var result = !!isIos;
      return result;
    },
    handleResize: function handleResize() {
      this.$toast('键盘弹起');
      var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (resizeHeight < this.originHeight) {
        // 当软键盘弹起，在此处操作
        if (!this.isIos()) {
          this.isFocus = true;
          this.$toast('键盘弹起');
        }
      } else {
        // 当软键盘收起，在此处操作
        if (!this.isIos()) {
          this.isFocus = false;
          this.$toast('键盘收起');
        }
      }
    },
    blur: function blur() {
      if (!this.inputValue) {
        this.isFocus = false;
        this.$refs.inputs.blur();
        this.item = '';
        params.replyId = '';
        this.placeholder = 'Say something';
      }
      // this.isFocus = false
      // this.inputValue = ''
      // this.isEmpty = true
    },
    focus: function focus() {
      this.isFocus = true;
      this.$refs.inputs.focus();
    },
    share: function share() {
      // this.$toast('开发中...')
      // return
      console.log(flag, 'flag');
      if (flag === 3 && this.qrcode) {
        this.draw();
      } else {
        this.$toast('picture loading incomplete');
      }
    },
    getShareModule: function getShareModule(imgSrc) {
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        window.Android.share(imgSrc);
      } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
        this.$bridge.callhandler('share', {
          'content': imgSrc
        }, function (response) {});
      }
    },
    draw: function draw() {
      var c = document.getElementById('canvas');
      c.setAttribute('width', getPx(660) + 'px');
      c.setAttribute('height', getPx(900) + 'px');
      // c.setAttribute('style', 'display:block;')
      // const timer = setTimeout(() => {
      //   c.setAttribute('style', 'display:none;')
      //   clearTimeout(timer)
      // }, 30000)
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#2c2e31';
      ctx.fillRect(0, 0, getPx(660), getPx(900));
      ctx.drawImage(img3, getPx(0), getPx(0), getPx(660), getPx(634));
      ctx.drawImage(img, getPx(25), getPx(468), getPx(70), getPx(70));
      ctx.drawImage(img1, getPx(578), getPx(794), getPx(50), getPx(50));
      ctx.drawImage(this.qrcode, getPx(25), getPx(724), getPx(150), getPx(150));
      ctx.font = "".concat(getPx(28), "px medium");
      ctx.fillStyle = ' #fff';
      ctx.fillText(this.detailData.user.nickname, getPx(112), getPx(487 + 28), getPx(522));
      ctx.font = "".concat(getPx(22), "px medium");
      ctx.fillStyle = 'rgba(255,255,255,0.50)';
      ctx.fillText('Scan QR Code', getPx(195), getPx(784 + 22), getPx(522));
      ctx.font = "".concat(getPx(22), "px medium");
      ctx.fillStyle = 'rgba(255,255,255,0.50)';
      ctx.fillText('Check The Details', getPx(195), getPx(814 + 22), getPx(522));
      // // 绘制多行文字
      // this.canvasTextAutoLine(str, c, 375 * 0.1, 640 * 0.5, 20)
      this.canvasImgSrc = c.toDataURL('image/png');
      console.log(this.canvasImgSrc, 'this.canvasImgSrc');
      this.getShareModule(this.canvasImgSrc);
    },
    canvasTextAutoLine: function canvasTextAutoLine(str, canvas, initX, initY, lineHeight) {
      var ctx = canvas.getContext('2d');
      var lineWidth = 0;
      var canvasWidth = document.documentElement.clientWidth;
      var lastSubStrIndex = 0;
      for (var i = 0; i < str.length; i++) {
        lineWidth += ctx.measureText(str[i]).width;
        if (lineWidth > canvasWidth * 0.8) {
          // 减去initX,防止边界出现的问题
          ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY);
          initY += lineHeight;
          lineWidth = 0;
          lastSubStrIndex = i;
        }
        if (i === str.length - 1) {
          ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY);
        }
      }
    },
    toFollow: function toFollow(userId) {
      var _this11 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          var params1 = {
            threadId: _this11.threadId
          };
          _this11.getDetail(params1);
        } else {
          _this11.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId) {
      var _this12 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          var params1 = {
            threadId: _this12.threadId
          };
          _this12.getDetail(params1);
        } else {
          _this12.$toast(res.Message);
        }
      });
    },
    back: function back() {
      var _this13 = this;
      var timer = setTimeout(function () {
        _this13.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    getKeyCode: function getKeyCode(e) {
      // this.$toast(e.keyCode)
      if (e.keyCode === 13) {
        // this.$toast('发送')
      }
    }
  }
};